import { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import SelectInput from '../inputs/SelectInput';
import { UPDATE_USER_PAYMENT_TYPE_MUTATION } from '../../queries/ratecards';
import { ALL_USERS_QUERY } from '../../queries/userQueries';

export function PaymentTypeSelector({ currentValue, userId }) {
  const [paymentType, setPaymentType] = useState(currentValue || '');
  const [updateUserPaymentType] = useMutation(UPDATE_USER_PAYMENT_TYPE_MUTATION, {
    refetchQueries: [{ query: ALL_USERS_QUERY }],
  });

  // Update selected value when currentValue changes
  useEffect(() => {
    setPaymentType(currentValue || '');
  }, [currentValue]);

  const handleChange = async (newType: string) => {
    setPaymentType(newType);

    if (!newType) return; // Don't update if empty selection

    try {
      await updateUserPaymentType({
        variables: {
          userId,
          paymentType: newType,
        },
      });
    } catch (err) {
      console.error('Failed to update payment type:', err);
      alert('Update failed');
      // Revert the selection on error
      setPaymentType(currentValue || '');
    }
  };

  const paymentOptions = [
    { name: 'Stripe', value: 'Stripe' },
    { name: 'Invoice', value: 'Invoice' }
  ];

  return (
    <SelectInput
      value={paymentType}
      onChange={handleChange}
      options={paymentOptions}
      small={true}
      className="min-w-0"
    />
  );
}
